// services/notificationService.ts - Updated version
import api from "./api";

const notificationService = {
  // User endpoints
  getUserNotifications: async (params?: any) => {
    try {
      const response = await api.get("/user/notifications", { params });
      return response.data;
    } catch (error: any) {
      console.error(
        "User notifications API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  markAsRead: async (id: number) => {
    try {
      const response = await api.post(`/user/notifications/${id}/read`);
      return response.data;
    } catch (error: any) {
      console.error("Mark as read API error:", error.response?.data || error);
      throw error;
    }
  },

  markAllAsRead: async () => {
    try {
      const response = await api.post("/user/notifications/read-all");
      return response.data;
    } catch (error: any) {
      console.error(
        "Mark all as read API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  dismissNotification: async (id: number) => {
    try {
      const response = await api.post(`/user/notifications/${id}/dismiss`);
      return response.data;
    } catch (error: any) {
      console.error(
        "Dismiss notification API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  dismissAllNotifications: async () => {
    try {
      const response = await api.post("/user/notifications/dismiss-all");
      return response.data;
    } catch (error: any) {
      console.error("Dismiss all API error:", error.response?.data || error);
      throw error;
    }
  },

  getNotificationStats: async () => {
    try {
      const response = await api.get("/user/notifications/statistics");
      return response.data;
    } catch (error: any) {
      console.error(
        "Notification stats API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  sendTestNotification: async (message?: string) => {
    try {
      const response = await api.post("/user/notifications/test", { message });
      return response.data;
    } catch (error: any) {
      console.error(
        "Test notification API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  // Admin endpoints
  getAdminNotifications: async (params?: any) => {
    try {
      const response = await api.get("/admin/notifications", { params });
      return response.data;
    } catch (error: any) {
      console.error(
        "Admin notifications API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  createNotification: async (data: any) => {
    try {
      const response = await api.post("/admin/notifications", data);
      return response.data;
    } catch (error: any) {
      console.error(
        "Create notification API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  updateNotification: async (id: number, data: any) => {
    try {
      const response = await api.put(`/admin/notifications/${id}`, data);
      return response.data;
    } catch (error: any) {
      console.error(
        "Update notification API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  deleteNotification: async (id: number) => {
    try {
      const response = await api.delete(`/admin/notifications/${id}`);
      return response.data;
    } catch (error: any) {
      console.error(
        "Delete notification API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  getAdminNotificationStats: async () => {
    try {
      const response = await api.get("/admin/notifications/statistics");
      return response.data;
    } catch (error: any) {
      console.error(
        "Admin notification stats API error:",
        error.response?.data || error
      );
      throw error;
    }
  },

  getNotificationRecipients: async (id: number) => {
    try {
      const response = await api.get(`/admin/notifications/${id}/recipients`);
      return response.data;
    } catch (error: any) {
      console.error("Get recipients API error:", error.response?.data || error);
      throw error;
    }
  },
};

export default notificationService;
